import { useSearchParams, useNavigate } from "react-router-dom";
import { ArrowUp, ArrowDown, FileText, Banknote, ArrowRight, ChevronLeft } from "lucide-react";
import AppShell from "../../components/AppShell";
import SaleForm from "../../components/mshop/SaleForm";
import PurchaseForm from "../../components/mshop/PurchaseForm";
import ExpenseForm from "../../components/mshop/ExpenseForm";

function ChoiceCard({ onClick, icon: Icon, title, desc, tone, testId }) {
    return (
        <button
            onClick={onClick}
            className={`group flex w-full items-center gap-4 rounded-[28px] border border-[#E7E5DF] bg-white p-6 text-right shadow-sm transition-transform hover:-translate-y-0.5 hover:shadow-md`}
            data-testid={testId}
        >
            <span className={`flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl ${tone}`}>
                <Icon className="h-8 w-8" />
            </span>
            <span className="flex-1">
                <span className="block font-heading text-2xl font-black text-neutral-900">{title}</span>
                <span className="mt-1 block text-sm text-neutral-500">{desc}</span>
            </span>
            <ChevronLeft className="h-5 w-5 text-neutral-400 transition-transform group-hover:-translate-x-1" />
        </button>
    );
}

function BottomNav({ mode, go, navigate }) {
    const item = (key, Icon, label, onClick) => (
        <button
            onClick={onClick}
            className={`flex flex-1 flex-col items-center gap-1 rounded-2xl py-2.5 text-sm transition-colors ${mode === key ? "bg-[#F6E7C1] font-bold text-neutral-900" : "text-neutral-500 hover:bg-neutral-50"}`}
            data-testid={`mshop-nav-${key}`}
        >
            <Icon className="h-5 w-5" />
            {label}
        </button>
    );
    return (
        <div className="mt-6 flex gap-2 rounded-3xl border border-[#E7E5DF] bg-white/95 p-2 shadow-lg backdrop-blur">
            {item("sale", ArrowUp, "بيع", () => go("sale"))}
            {item("purchase", ArrowDown, "شراء", () => go("purchase"))}
            {item("expense", Banknote, "مصاريف", () => go("expense"))}
            {item("records", FileText, "السجل", () => navigate("/mshop/records"))}
        </div>
    );
}

export default function MShopMovement() {
    const [params, setParams] = useSearchParams();
    const navigate = useNavigate();
    const mode = params.get("mode");
    const go = (m) => setParams(m ? { mode: m } : {});
    return (
        <AppShell>
            <div className="mx-auto max-w-xl pb-4" dir="rtl" data-testid="mshop-movement-page">
                {["sale", "purchase", "expense"].includes(mode) ? (
                    <>
                        <button onClick={() => go(null)} className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-white px-4 py-2 text-sm font-semibold text-neutral-700 shadow-sm ring-1 ring-[#E7E5DF] hover:bg-neutral-50" data-testid="mshop-back-to-choice">
                            <ArrowRight className="h-4 w-4" /> رجوع للاختيار
                        </button>
                        {mode === "sale" ? <SaleForm key="sale" /> : mode === "purchase" ? <PurchaseForm key="purchase" /> : <ExpenseForm key="expense" />}
                        <BottomNav mode={mode} go={go} navigate={navigate} />
                    </>
                ) : (
                    <>
                        <button onClick={() => navigate("/")} className="mb-4 inline-flex items-center gap-1.5 text-sm font-semibold text-neutral-600 hover:text-neutral-900" data-testid="mshop-back-home">
                            <ArrowRight className="h-4 w-4" /> الدفاتر
                        </button>
                        <h1 className="font-heading text-3xl font-black text-neutral-900">دفتر الحركة</h1>
                        <p className="mt-1 text-sm text-neutral-500">اختر نوع العملية</p>
                        <div className="mt-6 space-y-4">
                            <ChoiceCard onClick={() => go("sale")} icon={ArrowUp} title="بيع ذهب جديد" desc="الوزن • الكاش • البنك • البيان" tone="bg-[#F6E7C1] text-[#8A6A1F]" testId="mshop-choose-sale" />
                            <ChoiceCard onClick={() => go("purchase")} icon={ArrowDown} title="شراء ذهب مستعمل" desc="الوزن • الكاش • البنك • البيان" tone="bg-[#E3F1E8] text-emerald-800" testId="mshop-choose-purchase" />
                            <ChoiceCard onClick={() => go("expense")} icon={Banknote} title="المصاريف" desc="الكاش • البنك • البيان" tone="bg-[#EDE9E0] text-[#64563A]" testId="mshop-choose-expense" />
                        </div>
                    </>
                )}
            </div>
        </AppShell>
    );
}
